import _regeneratorRuntime from "/codebuild/output/src386676321/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(runTokenRefresh),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleTokenRefresh),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(runSuccessTokenRefresh),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleSuccessTokenRefresh),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(rootSagas);

import { call, fork, put, takeLatest } from 'redux-saga/effects';
import * as actions from '../actions/user_refresh';
import { execRefresh } from '../models/user_refresh';
import { getIsLogin } from '../models/user';
import { setToken } from '../models/signIn';
export function runTokenRefresh() {
  var isLogin, _ref, payload, error;

  return _regeneratorRuntime.wrap(function runTokenRefresh$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return call(getIsLogin);

        case 2:
          isLogin = _context.sent;

          if (!isLogin) {
            _context.next = 16;
            break;
          }

          _context.next = 6;
          return call(execRefresh);

        case 6:
          _ref = _context.sent;
          payload = _ref.payload;
          error = _ref.error;

          if (!(payload && !error)) {
            _context.next = 14;
            break;
          }

          _context.next = 12;
          return put(actions.successTokenRefresh(payload));

        case 12:
          _context.next = 16;
          break;

        case 14:
          _context.next = 16;
          return put(actions.failureTokenRefresh(error));

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function handleTokenRefresh() {
  return _regeneratorRuntime.wrap(function handleTokenRefresh$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(actions.requestTokenRefresh.type, runTokenRefresh);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function runSuccessTokenRefresh(action) {
  return _regeneratorRuntime.wrap(function runSuccessTokenRefresh$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return call(setToken, action.payload);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function handleSuccessTokenRefresh() {
  return _regeneratorRuntime.wrap(function handleSuccessTokenRefresh$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeLatest(actions.successTokenRefresh.type, runSuccessTokenRefresh);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
export default function rootSagas() {
  return _regeneratorRuntime.wrap(function rootSagas$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return fork(handleTokenRefresh);

        case 2:
          _context5.next = 4;
          return fork(handleSuccessTokenRefresh);

        case 4:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}